import {
    CREATE_SUBCATEGORY,
    CREATE_SUBCATEGORY_FAILURE,

    CREATE_SUBCATEGORY_LOCALISATION,
    CREATE_SUBCATEGORY_LOCALISATION_FAILURE,
    CREATE_SUBCATEGORY_LOCALISATION_SUCCESS,
} from 'store/actions/types';

export const createSubcategory = (payload) => {
    return {
        type: CREATE_SUBCATEGORY,
        payload: payload,
    };
};

export const createSubcategoryFailure = (error) => {
    return {
        type: CREATE_SUBCATEGORY_FAILURE,
        error: error,
    };
};

export const createSubcategoryLocalisation = (payload, response) => {
    return {
        type: CREATE_SUBCATEGORY_LOCALISATION,
        payload: payload,
        response: response,
    };
};

export const createSubcategoryLocalisationFailure = (error) => {
    return {
        type: CREATE_SUBCATEGORY_LOCALISATION_FAILURE,
        error: error,
    };
};

export const createSubcategoryLocalisationSuccess = (payload, response) => {
    return {
        type: CREATE_SUBCATEGORY_LOCALISATION_SUCCESS,
        payload: payload,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/subcategories/createSubcategories.js